import { render, staticRenderFns } from "./Nofound.vue?vue&type=template&id=3f605e87&"
import script from "./Nofound.vue?vue&type=script&lang=js&"
export * from "./Nofound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports